import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../../../core';
import { Alert, Loader } from '../../../../components';
import * as Forms from '../../../../components/forms';
import Translate from '../../../../core/translate';
import API from '../../../../services/api';
import { IVoucher } from '../../../../services/api/entity/model';
import { IResponse } from '../../../../services/model';
import Common, { FormService } from '../../../../services/common';

interface IProps {
  storage?: IDataStorage;
  refService?: (form:FormService<IVoucher>) => void;

  id?: number;
  readonly?: boolean;

  entity?: () => IVoucher | undefined; // opcionalmente se recibe el objeto a editar
}

interface IState {
  storage?: IDataStorage;

  id?: number;
  readonly?: boolean;

  loading?: {
    entity?: boolean;
  }

  entity?: IVoucher;
}

class Index extends React.Component<IProps, IState> {
  form : FormService<IVoucher>;
  constructor(props:IProps) {
    super(props);
    this.form = Common.form(() => this.getEntity);
  }

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.loadEntities(this.state.id);
    this.props.refService && this.props.refService(this.form);
  }

  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.id !== s?.id) res.id = p.id;
    if (p?.readonly !== s?.readonly) res.readonly = p.readonly;
    return res;
  }

  private loadEntities = (id?: number) => {
    const t = Translate.get("config/voucher/form", this.state.storage?.languaje);
    if (!!this.props.entity) {
      const entity = this.props.entity();
      if (!!entity) {
        this.setState({ entity: this.form.setEntity(entity), loading: { ...this.state.loading, ...{ entity: false } } })
        return;
      }
    }
    if (id) {
      this.setState({ loading: { ...this.state.loading, ...{ entity: true } } }, () => {
        API.entity().remitente().get({ id })
          .then(entity => {
            Alert.reponse(entity);
            if (entity.success) {
              this.setState({ entity: this.form.setEntity(entity.data), loading: { ...this.state.loading, ...{ entity: false } } })
            }
          })
          .catch(e => Alert.error(t("Load.Error"), e));
      });
    }
  }

  private change = (field: string, value: any, error?: string, callback?: () => void) => {
    this.setState({ entity:this.form.setValue(field, value, error) }, callback);
  }

  render() {
    const { loading, readonly, entity } = this.state;
    const t = Translate.get("config/voucher/form", this.state.storage?.languaje);

    const idiomas = idiomasall.map(p => ({ id:p.id, label:t(p.label) }));
    return (
      <Loader loading={loading?.entity}>
        <Forms.Input form={this.form} name='codigo' title={t("Col.codigo")} required placeholder={t("Col.codigo.Placeholder")} disabled={readonly} value={entity?.codigo} onChange={(v, e) => this.change('codigo', v, e)} />
        <Forms.Dropdown form={this.form} name="idioma" options={() => idiomas} optionValue="id" optionLabel="label" title={t("Col.idioma")} placeholder={t("Col.idioma.Placeholder")} disabled={readonly} value={entity?.idioma} onChange={(v, e) => this.change('idioma', v, e)} />
        <Forms.Input form={this.form} name='descripcion' title={t("Col.descripcion")} placeholder={t("Col.descripcion.Placeholder")} disabled={readonly} value={entity?.descripcion} onChange={(v, e) => this.change('descripcion', v, e)} />
        <Forms.UploadSingleFile form={this.form} name='file' maxSize={1000} required title={t("Col.file")} placeholder={t("Col.file.Placeholder")} disabled={readonly} accept="*.*" value={entity?.file} onChange={(v, e) => this.change('file', v, e)} />
      </Loader>
    );
  }
  
  /** devuelve la entidad */
  getEntity = () : IResponse<IVoucher> => {
    var isValid = this.form.isFormValid();
    if (!isValid) {
      return { success: false, error: (this.form.getStatus().errors ?? [])[0] };
    } else {
      const data = this.form.form.getEntity();
      return { success: true, data };
    }
  }
}

export { Index }
export default connect((s:any) => ({ storage:s.main }))(Index);

const idiomasall = [
  { id: undefined, label: '@API.Idioma#undefined' },
  { id: 1, label: '@API.Idioma#es' },
  { id: 2, label: '@API.Idioma#en' },
]